var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-radio',_vm._g(_vm._b({staticClass:"tslc-radio-button",scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('p',{staticClass:"tslc-radio-button__value",attrs:{"disabled":true}},[_vm._v(_vm._s(_vm.label))])]},proxy:true}])},'v-radio',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }